import { useState } from 'react';
import { useStore } from '../store.js';

const MAX = 25 * 1024 * 1024;

// Accept: any image (jpg/png/heic/heif/webp/gif/tiff), PDF, Word docs, and CSV.
const DEFAULT_ACCEPT = 'image/*,application/pdf,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.csv,text/csv';

export function FileUpload({ category, label, accept = DEFAULT_ACCEPT }) {
  const documents = useStore((s) => s.documents);
  const uploadDocuments = useStore((s) => s.uploadDocuments);
  const removeDocument = useStore((s) => s.removeDocument);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const docs = documents.filter((d) => d.category === category);

  async function onChange(e) {
    setError(null);
    const files = [...e.target.files];
    for (const f of files) {
      if (f.size > MAX) {
        setError(`"${f.name}" exceeds 25 MB`);
        return;
      }
    }
    setBusy(true);
    try {
      await uploadDocuments(category, files);
    } catch {
      setError('Upload failed. Please try again.');
    } finally {
      setBusy(false);
      e.target.value = '';
    }
  }

  return (
    <div className="space-y-2">
      <label className="field-label">{label}</label>
      <label className={`relative flex items-center justify-center w-full border-2 border-dashed rounded-md py-6
                          ${busy ? 'opacity-50 cursor-wait' : 'cursor-pointer hover:border-brand-500'}
                          border-slate-300 bg-white text-sm text-slate-500`}>
        <input type="file" multiple accept={accept} onChange={onChange} disabled={busy}
          className="absolute inset-0 w-full h-full opacity-0 cursor-pointer disabled:cursor-wait" />
        {busy ? 'Uploading…' : 'Click or drop files here'}
      </label>
      {error && <p className="field-error">{error}</p>}
      {docs.length > 0 && (
        <ul className="divide-y divide-slate-200 rounded-md ring-1 ring-slate-200 bg-white">
          {docs.map((d) => (
            <li key={d.id} className="flex items-center justify-between px-3 py-2 text-sm">
              <span className="truncate">{d.file_name}</span>
              <button onClick={() => removeDocument(d.id)} className="text-red-600 hover:underline text-xs">
                Remove
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
